import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IoMdCall } from "react-icons/io";
import { Link, useNavigate } from 'react-router-dom';
import './index.css';

const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar-rk">
      <div className="logo-container-rk">
        <img src="/images/mainlogo.jpg" onClick={() => { navigate('/') }} alt="website logo" className="website-logo-rk" />
        <div className="logo-rk">
          <span className="logo-part1-rk">RK</span>
          <span className="logo-part2-rk">Housing</span>
        </div>
      </div>

      {/* Desktop Navigation */}
      <div className={`nav-links-rk ${menuOpen ? 'open-rk' : ''}`}>
        <Link to="/" onClick={handleCloseMenu}>Home</Link>
        <Link to="/about" onClick={handleCloseMenu}>About</Link>
        <Link to="/listing" onClick={handleCloseMenu}>Listings</Link>
        <Link to="/contact" onClick={handleCloseMenu}>Contact</Link>
      </div>

      <div className="contact-info-rk">
        <button className="cta-button-rk" onClick={() => { navigate('/contact') }}>
          <IoMdCall size={25} />
          Schedule Call
        </button>
      </div>

      {/* Mobile Menu Button */}
      <button className="menu-button-rk" onClick={handleMenuToggle}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Mobile Menu */}
      <div className={`mobile-menu-rk ${menuOpen ? 'show-rk' : ''}`}>
        <Link to="/" onClick={handleCloseMenu}>Home</Link>
        <Link to="/about" onClick={handleCloseMenu}>About</Link>
        <Link to="/listing" onClick={handleCloseMenu}>Listings</Link>
        <Link to="/contact" onClick={handleCloseMenu}>Contact</Link>
        <button className="cta-button-rk" onClick={()=>{
          navigate('/contact');
          handleCloseMenu();
        }}>Schedule Call</button>
      </div>
    </nav>
  );
};

export default Navbar;
